var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkStatusStable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 4,
    height: 16,
    rx: 2,
    fill: "url(#paint0_linear_147_12823)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 4,
    height: 12,
    rx: 2,
    fill: "url(#paint1_linear_147_12823)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 4,
    height: 8,
    rx: 2,
    fill: "url(#paint2_linear_147_12823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_12823",
    x1: 22,
    y1: 12,
    x2: 14.4706,
    y2: 10.1176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_12823",
    x1: 16,
    y1: 14,
    x2: 8.8,
    y2: 11.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_147_12823",
    x1: 10,
    y1: 16,
    x2: 3.6,
    y2: 12.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkStatusStable);
export default __webpack_public_path__ + "static/media/network-status-stable.c673e85a44e383c02f564d6f3414b9d2.svg";
export { ForwardRef as ReactComponent };